import React from "react";
import PaceReportIcon from "assets/svgIcons/AdminDashboard/PaceReportIcon";
import PaceReport from "assets/images/pace-report-image.png";
import { useTranslation } from "react-i18next";

export const PaceReports = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="header">
        <PaceReportIcon />
        <p>{t("Current_Pace")}</p>
      </div>
      <div className="box-body pace-report">
        <img src={PaceReport} alt="pace-report" />
      </div>
    </>
  );
};
